import { getWithAuth } from './api/client';
import { apiVariables } from './api/apiVariables';
import type { WorkforceIntelligenceDashboard } from '../types/workforceIntelligence';

interface ApiResponse<T> { success: boolean; message?: string; data?: T; }

export async function getWorkforceIntelligence(days = 30): Promise<WorkforceIntelligenceDashboard> {
  const response = await getWithAuth<ApiResponse<WorkforceIntelligenceDashboard>>(`${apiVariables.WORKFORCE_INTELLIGENCE_DASHBOARD}?days=${days}`);
  if (!response.success || !response.data) throw new Error(response.message || 'Unable to load workforce intelligence.');
  return response.data;
}

// Manager Center (Availability Approvals / Workforce Intelligence / Reports) is only
// shown/reachable when this succeeds — it's the backend's source of truth for manager access.
export async function checkManagerCenterAccess(days = 30): Promise<boolean> {
  try {
    const response = await getWithAuth<ApiResponse<WorkforceIntelligenceDashboard>>(`${apiVariables.WORKFORCE_INTELLIGENCE_DASHBOARD}?days=${days}`);
    return response.success === true;
  } catch {
    return false;
  }
}
